<div class="tw-inline-flex tw-gap-2">
  <ng-container *ngFor="let item of filteredItems; let last = last">
    <span bitBadge [badgeType]="badgeType" [truncate]="truncate">
      {{ item }}
    </span>
    <span class="tw-sr-only" *ngIf="!last || isFiltered">, </span>
  </ng-container>
  <span *ngIf="isFiltered" bitBadge [badgeType]="badgeType">
    {{ "plusNMore" | i18n : (items.length - filteredItems.length).toString() }}
  </span>
</div>
